import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=0015d277&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0015d277')) {
      api.createRecord('0015d277', component.options)
    } else {
      api.reload('0015d277', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=0015d277&", function () {
      api.rerender('0015d277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/svg-media/reset.vue"
export default component.exports